import { useBalanceStore } from '@/context/UserBalance'
import { colors } from '@/theme'
import { SimpleGrid, Button, ButtonProps } from '@chakra-ui/react'
import { useFiatCurrencyStore } from '@/context/FiatCurrencyStore'
import { USDC_NEW_DENOM } from '@/constants/constants'
import { roundFiatBet, formatFiatDisplay } from '@/helpers/fiatUtils'

export const AmountButtons = ({
  disabled,
  maxValue,
  denom,
  setAmount,
  amount,
}: {
  disabled?: boolean
  maxValue: number
  denom: string
  setAmount: (value: string) => void
  amount: string
}) => {
  const fiat = useFiatCurrencyStore()
  const isFiatMode = !fiat.isUsd() && denom === USDC_NEW_DENOM

  const preset1 = Math.round(maxValue * 10) / 1_000
  const preset2 = Math.round(maxValue * 100) / 1_000

  const label = (usdc: number) =>
    isFiatMode ? formatFiatDisplay(roundFiatBet(fiat.usdcToFiat(usdc), 'nearest'), fiat.getSymbol()) : String(usdc)

  const handleSetAmount = (amount: number) => {
    setAmount(amount.toString())
  }

  const handleMax = () => {
    setAmount(useBalanceStore.getState().balance[denom].amount.humanFormat)
  }

  const handleMultiplyAmount = (multiplier: number) => {
    setAmount((Number(amount) * multiplier).toString())
  }

  return (
    <SimpleGrid columns={5} gap={1} w={'full'}>
      <StyledButton isDisabled={disabled} onClick={() => handleSetAmount(preset1)}>
        {label(preset1)}
      </StyledButton>
      <StyledButton isDisabled={disabled} onClick={() => handleSetAmount(preset2)}>
        {label(preset2)}
      </StyledButton>
      <StyledButton isDisabled={disabled} onClick={() => handleMultiplyAmount(0.5)}>
        1/2
      </StyledButton>
      <StyledButton isDisabled={disabled} onClick={() => handleMultiplyAmount(2)}>
        X2
      </StyledButton>
      <StyledButton isDisabled={disabled} onClick={() => handleMax()}>
        MAX
      </StyledButton>
    </SimpleGrid>
  )
}

export const StyledButton = (buttonProps: ButtonProps) => {
  return (
    <Button
      h={9}
      variant={'unstyled'}
      bg={'ninja.500'}
      color={'ninja.300'}
      border={'none'}
      size={'sm'}
      transition={'none'}
      _disabled={{
        opacity: 0.6,
        bg: 'ninja.500',
        cursor: 'not-allowed',
      }}
      _hover={{
        bgGradient: colors.gradient.primary,
        filter: `drop-shadow(0 4px 25px rgba(110, 97, 253, .51))`,
        color: 'white',
        _disabled: {
          bg: 'ninja.500',
          filter: 'none',
          color: 'ninja.200',
        },
      }}
      _active={{
        bgGradient: colors.gradient.secondary,
        color: 'white',
      }}
      {...buttonProps}
    >
      {buttonProps.children}
    </Button>
  )
}
